import * as React from "react";
import { FC, useEffect, useState } from "react";
import { withPrivateRoute } from "../security/AckAuth";
import {
  EmbeddedCreateResource,
  EmbeddedGroupListResource,
  EmbeddedListResource,
  EmbeddedProps,
  EmbeddedViewResource,
  OnResourceChangeListener,
} from "./AckEmbeddedResources";
import { Route, Routes } from "react-router-dom";

/** Props allowing rerouting if errors (e.g. authentication) occur. */
export type RerouteProps = {
  /** The path to return to if an error occurs. */
  returnTo: string;
}

/** Props for the AckResource component. */
export type Props = EmbeddedProps & OnResourceChangeListener

/** Props for the PrivateAckResource component. */
export type PrivateProps = Props & RerouteProps

/** The component rendering a list of resources. */
const ListResource: FC<Props> = (props) => {
  return (
    <div className="section">
      <h1 className="title">Listing {props.name}</h1>
      <EmbeddedListResource {...props} />
    </div>
  );
};

/** The component rendering a grouped list of resources. */
const GroupListResource: FC<Props> = (props) => {
  return (
    <div className="section">
      <h1 className="title">Listing {props.name}</h1>
      <EmbeddedGroupListResource {...props} />
    </div>
  );
};

/** The component rendering a single resource. */
const ViewResource: FC<Props> = (props) => {
  return (
    <div className="section">
      <h1 className="title">Viewing {props.name}</h1>
      <EmbeddedViewResource {...props} />
    </div>
  );
};

/** The component rendering the creation form for a single resource. */
const CreateResource: FC<Props> = (props) => {
  return (
    <div className="section">
      <h1 className="title">Create new {props.name}</h1>
      <EmbeddedCreateResource {...props} />
    </div>
  );
};

/** The component encapsulating the different presentation modes for a single resource. */
export const AckResource: FC<EmbeddedProps & OnResourceChangeListener> = (props) => {
  const [state, setState] = useState({ ...props });
  useEffect(() => setState({ ...props }), [props]);

  const List = () => {
    if (props.listOptions != null) {
      return (<GroupListResource {...state}/>);
    }
    return (<ListResource {...state}/>);
  };
  return (
    <Routes>
      <Route path="/" element={<List/>}/>
      <Route path="create" element={<CreateResource {...state} />}/>
      <Route path=":id/:type" element={<ViewResource {...state} />}/>
    </Routes>
  );
};

/** A decorator that includes authentication checks for the embedded resource. */
export const PrivateAckResource: FC<PrivateProps> = (props) => {
  // FIXME: This returnTo is not working as expected
  const returnTo = () => props.returnTo;
  const PrivateResourceRoute = withPrivateRoute(() => (<AckResource {...props}/>), returnTo);
  return (<PrivateResourceRoute/>);
};
